import { render, staticRenderFns } from "./UpdatesFeed.vue?vue&type=template&id=20186022&scoped=true"
import script from "./UpdatesFeed.vue?vue&type=script&lang=js"
export * from "./UpdatesFeed.vue?vue&type=script&lang=js"
import style0 from "./UpdatesFeed.vue?vue&type=style&index=0&id=20186022&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20186022",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VProgressCircular,VRow})
